module.exports = "<p>\n  product-details works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// E:/Project/posSystem/src/app/pos/home/product/product-details/product-details.component.html
// module id = ../../../../../src/app/pos/home/product/product-details/product-details.component.html
// module chunks = main